<template>
  <!-- 一个视频 -->
  <div class="id_9 clear">
    <div class="img_box">
      <video ref="video" controlslist="nodownload" @contextmenu.prevent="contextmenu" controls :src="data.src">
        {{$t('flowActive15')}}
      </video>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: Object
  },
  name: 'id_9',
  methods: {
    // 右键事件
    contextmenu () {
    },
    // 初始化
    init () {
      this.$api.post('COMMON_API_GET_FILE', {id: this.data.fileId}, ({ data }) => {
        this.$refs.video.src = data.url
      })
    }
  },
  created () {
    if (this.data.fileId) {
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
.id_9{
  padding-top: 24px;
  background-color: #fff;
  .img_box{
    width: 100%;
    video{
      width: 100%;
    }
    video::-internal-media-controls-download-button {
      display:none;
    }
    video::-webkit-media-controls-enclosure {
      overflow:hidden;
    }
    video::-webkit-media-controls-panel {
      width: calc(100% + 30px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/id_9.vue